import {
	mapState,
	mapGetters,
	mapActions
} from 'vuex';

import {
	isEmpty
} from 'lodash';

import {
	EventBus
} from '@/support/event-bus';

import vSelect from 'vue-select';

import store from './store';

export default {
	...store,
	name: 'school-class-list',
	props: {
		context: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: 'Class'
		},
		multiple: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			default: false
		},
		group: {
			type: Boolean,
			default: true
		},
		withStudents: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		defaultValueText: {
			type: String,
			default: 'Selecione'
		},
		onlySelect: {
			type: Boolean,
			default: false
		},
		byTheme: {
			type: Boolean,
			default: false
		},
		scope: {
			type: String,
			default: 'global' // global, local
		},
		filter: {
			type: String,
			default: '' // '' all / 1 extracurricular / 0 regular
		}
	},
	components: {
		vSelect
	},
	data: () => ({
		schoolClass: [],
		classList: '',
		selected: {},
		list: []
	}),
	computed: {
		...mapState({
			classes: (state) => state.Class,
			user: (state) => state.Logged.user,
			students: (state) => state.Student.list
		}),
		...mapGetters([
			'getLoggedUser',
			'classGrade',
			'classGradeList',
			'getClass',
			'album',
			'currentTheme'
		])
	},
	methods: {
		...mapActions([
			'setSelectedClass',
			'setStudent',
			'getClassByUser',
			'getStudents'
		]),
		changed() {

			if (!this.multiple) {

				if (this.scope === 'local') {
					this.selected = this.classList;
				} else {

					this.setStudent({});
					this.setSelectedClass(this.classList);

				}

			} else {
				this.setSelectedClass(this.schoolClass);
			}

			EventBus.$emit('classChanged', {
				context: this.context,
				data: this.scope === 'local' ? this.selected : this.getClass
			});

		},
		defaultResponse(response) {

			if (this.scope === 'local') {
				this.list = response.data.object;
			}

		}
	},
	mounted() {

		if (this.scope === 'global') {
			this.list = this.classes.list;
		}

		if (this.context === 'gallery' && this.multiple) {
			this.schoolClass = this.album.schoolClasses;
			this.setSelectedClass(this.schoolClass);
		}

		if (this.context === 'gallery' && !this.multiple) {
			this.classList = this.album.schoolClasses;
		}

		if (!isEmpty(this.getClass)) {
			this.classList = this.getClass;
		}

		EventBus.$on('classGradeSelected', (payload) => {

			this.getClassByUser({
				userId: this.getLoggedUser.id,
				scope: this.scope,
				filter: {
					gradeId: payload.gradeId
				}
			}).then(this.defaultResponse);

		});

		if (this.byTheme) {

			this.getClassByUser({
				userId: this.getLoggedUser.id,
				scope: this.scope,
				filter: {
					themeId: this.currentTheme.schoolThemeId
				}
			}).then(this.defaultResponse);

			EventBus.$on('themeSelected', (theme) => {

				this.getClassByUser({
					userId: this.getLoggedUser.id,
					scope: this.scope,
					filter: {
						themeId: theme.schoolThemeId
					}
				}).then(this.defaultResponse);

			});

		} else {

			this.getClassByUser({
				userId: this.getLoggedUser.id,
				scope: this.scope,
				extracurricular: this.filter
			}).then(this.defaultResponse);

		}

		this.$store.watch((state) => state.Class.list, (newClassList) => {
			this.list = newClassList;
		});

		this.$store.watch((state) => state.Class.selected, (newClass) => {

			if (this.withStudents && newClass !== undefined) {

				this.getStudents({
					userId: this.getLoggedUser.id,
					schoolClassId: newClass.schoolClassId,
					scope: this.scope
				});
			}

		});

	},
	beforeDestroy() {

		EventBus.$off('classGradeSelected');
		EventBus.$off('classChanged');
		EventBus.$off('themeSelected');

	}
};



// WEBPACK FOOTER //
// ./sources/domains/school/class-list/index.js